/**
 * SelfAbout /search — own search bar + Predictive Search live results.
 * Replaces fragile theme clears / shadow-DOM resets.
 */
(function () {
  var path = (location.pathname || "/").replace(/\/$/, "") || "/";
  if (!/\/search$/i.test(path)) return;
  if (window.__saSearchBoot) return;
  window.__saSearchBoot = 1;

  document.documentElement.setAttribute("data-selfabout-search-page", "1");
  document.documentElement.classList.add("selfabout-js", "sa-search-ready");

  var liveAbort = null;
  var lastQ = null;
  var defaultGen = 0;
  var catalogCache = null;
  var catalogPromise = null;
  var moneyFormat =
    (window.Shopify && window.Shopify.money_format) || "${{amount}}";

  function markBody() {
    if (document.body) {
      document.body.classList.add("template-search", "sa-search-page");
      document.body.classList.remove("sa-search");
    }
  }
  markBody();
  if (!document.body) document.addEventListener("DOMContentLoaded", markBody);

  function assetBase() {
    var link = document.querySelector(
      'link[href*="selfabout-pages.css"],link[href*="selfabout-tokens.css"],link[href*="selfabout-embed.css"],link[href*="selfabout-search.css"]',
    );
    if (!link || !link.href) return null;
    var match = link.href.match(/^(.*\/)selfabout-[a-z0-9-]+\.css(.*)$/i);
    return match ? { base: match[1], query: match[2] || "" } : null;
  }

  function ensureCss(name) {
    if (document.querySelector('link[href*="' + name + '.css"]')) return;
    var parts = assetBase();
    if (!parts) return;
    var el = document.createElement("link");
    el.rel = "stylesheet";
    el.href = parts.base + name + ".css" + parts.query;
    document.head.appendChild(el);
  }

  function ensureJs(name) {
    if (document.querySelector('script[src*="' + name + '.js"]')) return;
    var parts = assetBase();
    if (!parts) {
      var scriptHit = document.querySelector(
        'script[src*="selfabout-search.js"],script[src*="selfabout-embed.js"],script[src*="selfabout-nav-boot.js"]',
      );
      if (scriptHit && scriptHit.src) {
        var match = scriptHit.src.match(/^(.*\/)selfabout-[a-z0-9-]+\.js(.*)$/i);
        if (match) parts = { base: match[1], query: match[2] || "" };
      }
    }
    if (!parts) return;
    var el = document.createElement("script");
    el.src = parts.base + name + ".js" + parts.query;
    el.defer = true;
    document.head.appendChild(el);
  }

  ensureCss("selfabout-search");
  ensureCss("selfabout-collection");
  ensureCss("selfabout-card-off");
  ensureCss("selfabout-offer-labels");
  ensureCss("selfabout-kit-media");
  ensureJs("selfabout-collection");
  ensureJs("selfabout-kit-media");
  ensureJs("selfabout-card-off");
  ensureJs("selfabout-offer-labels");

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function currentQuery() {
    try {
      return new URLSearchParams(location.search).get("q") || "";
    } catch (_e) {
      return "";
    }
  }

  function formatMoney(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return "";
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(n, moneyFormat);
      } catch (_e) {}
    }
    return "Rs." + (n / 100).toFixed(2);
  }

  function findThemeSearchMount() {
    /* Prefer the form wrapper so we can insert SA bar as a SIBLING, never inside it */
    return (
      qs(".search-page-input__parent") ||
      qs(".search-page__header form") ||
      qs('form[action*="/search"]') ||
      qs("search-page-input-component") ||
      qs(".search-page__header")
    );
  }

  function findSearchHeading() {
    var hit =
      qs(".search-page__header h1") ||
      qs(".search-page__header h2") ||
      qs(".search-page__header h3") ||
      qs(".search-page__header .h1") ||
      qs(".search-page__header .h2") ||
      qs(".search-page__header .h3") ||
      qs(".search-page__header .text-block") ||
      null;
    if (hit) return hit;
    var nodes = qsa(
      "#MainContent h1, #MainContent h2, #MainContent h3, #MainContent .h1, #MainContent .h2, #MainContent .h3, #MainContent .text-block, main h1, main h2, main h3",
    );
    for (var i = 0; i < nodes.length; i++) {
      var t = (nodes[i].textContent || "").replace(/\s+/g, " ").trim();
      if (/^search$/i.test(t)) return nodes[i];
    }
    return null;
  }

  function hideAllThemeSearchChrome() {
    var sels = [
      "search-page-input-component",
      ".search-page-input__parent",
      ".search__input-wrapper",
      "predictive-search",
      "form[action*='/search'] input[name='q']",
      "form[action*='/search'] input[type='search']",
      "input.search-page-input",
      "input[type='search'][name='q']",
    ];
    sels.forEach(function (sel) {
      try {
        qsa(sel).forEach(function (el) {
          /* Never hide a node that contains our SA bar */
          if (el.closest && el.closest("[data-sa-search-bar]")) return;
          if (el.querySelector && el.querySelector("[data-sa-search-bar]")) return;
          el.setAttribute("data-sa-theme-search-hidden", "1");
          el.setAttribute("aria-hidden", "true");
          el.style.setProperty("display", "none", "important");
          el.style.setProperty("visibility", "hidden", "important");
          el.style.setProperty("pointer-events", "none", "important");
          if (el.tagName === "INPUT") {
            el.disabled = true;
            el.removeAttribute("required");
          }
          qsa("input", el).forEach(function (input) {
            input.disabled = true;
            input.removeAttribute("required");
          });
        });
      } catch (_e) {}
    });
  }

  function hideThemeSearchChrome(mount) {
    hideAllThemeSearchChrome();
    if (!mount) return;
    if (mount.querySelector && mount.querySelector("[data-sa-search-bar]")) return;
    if (
      mount.matches &&
      mount.matches(
        "search-page-input-component, .search-page-input__parent, form[action*='/search']",
      )
    ) {
      mount.setAttribute("data-sa-theme-search-hidden", "1");
      mount.style.setProperty("display", "none", "important");
    }
  }

  function placeBarSafely(bar, heading, header, mount) {
    /* Always sibling of theme form — never a descendant (display:none parent kills bar) */
    var form =
      (mount &&
        mount.matches &&
        mount.matches(".search-page-input__parent, form[action*='/search']") &&
        mount) ||
      (mount && mount.closest && mount.closest(".search-page-input__parent, form[action*='/search']")) ||
      qs(".search-page-input__parent") ||
      qs('form[action*="/search"]');
    if (form && form.parentNode) {
      hideThemeSearchChrome(form);
      if (bar.parentNode !== form.parentNode || bar.previousSibling !== form) {
        form.parentNode.insertBefore(bar, form.nextSibling);
      }
      return true;
    }
    if (heading && heading.parentNode) {
      heading.parentNode.insertBefore(bar, heading.nextSibling);
      return true;
    }
    if (header) {
      header.appendChild(bar);
      return true;
    }
    if (qs("#MainContent")) {
      qs("#MainContent").insertBefore(bar, qs("#MainContent").firstChild);
      return true;
    }
    if (document.body) {
      document.body.insertBefore(bar, document.body.firstChild);
      return true;
    }
    return false;
  }

  function buildBarEl() {
    var bar = document.createElement("div");
    bar.className = "sa-search-bar";
    bar.setAttribute("data-sa-search-bar", "1");
    bar.innerHTML =
      '<label class="sa-search-bar__field">' +
      '<span class="visually-hidden">Search</span>' +
      '<input class="sa-search-bar__input" type="text" name="q" autocomplete="off" spellcheck="false" enterkeyhint="search" placeholder="Search bundles and products" />' +
      '<div class="sa-search-bar__actions">' +
      '<button type="button" class="sa-search-bar__clear" aria-label="Clear search" hidden>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M15.2 8.8 8.8 15.2M8.8 8.8l6.4 6.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      "</button>" +
      '<button type="button" class="sa-search-bar__submit" aria-label="Search">' +
      '<span class="sa-search-bar__submit-icon" aria-hidden="true">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.8"/><path d="M16.2 16.2 20 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      "</span>" +
      '<span class="sa-search-bar__submit-spin" aria-hidden="true"></span>' +
      "</button>" +
      "</div>" +
      "</label>" +
      '<p class="sa-search-bar__hint" data-sa-search-hint>' +
      "<span>Type a keyword</span><span class=\"sa-search-bar__hint-dot\" aria-hidden=\"true\"></span>" +
      "<span>Press search for all products</span><span class=\"sa-search-bar__hint-kbd\" aria-hidden=\"true\">↵</span>" +
      "</p>";
    return bar;
  }

  function ensureBar() {
    var existing = qs("[data-sa-search-bar]");
    if (existing && !qs(".sa-search-bar__submit", existing)) {
      try {
        existing.parentNode.removeChild(existing);
      } catch (_e) {}
      existing = null;
    }
    var heading = findSearchHeading();
    var header =
      (heading &&
        heading.closest(
          ".search-page__header, .shopify-section, section, .section",
        )) ||
      qs(".search-page__header") ||
      null;
    var mount = findThemeSearchMount();

    if (existing) {
      existing.hidden = false;
      existing.style.removeProperty("display");
      existing.style.removeProperty("visibility");
      existing.style.setProperty("display", "block", "important");
      /* Relocate if trapped inside a hidden theme form */
      var trapped =
        existing.closest &&
        existing.closest(
          ".search-page-input__parent, search-page-input-component, [data-sa-theme-search-hidden], form[action*='/search']",
        );
      if (trapped) {
        placeBarSafely(existing, heading, header, mount);
      }
      /* Always keep bar under Search title section (above results) */
      try {
        var mainEx = qs("#MainContent");
        var headEx = qs(".search-page__header");
        var secEx =
          (headEx && headEx.closest && headEx.closest(".shopify-section")) ||
          (existing.closest && existing.closest(".shopify-section"));
        if (mainEx && secEx && secEx.parentNode === mainEx) {
          if (
            existing.parentNode !== mainEx ||
            existing.previousElementSibling !== secEx
          ) {
            mainEx.insertBefore(existing, secEx.nextSibling);
          }
        }
      } catch (_ex) {}
      hideAllThemeSearchChrome();
      return existing;
    }

    hideAllThemeSearchChrome();
    var bar = buildBarEl();
    if (!placeBarSafely(bar, heading, header, mount)) return null;
    /* Keep bar under the Search title, outside hidden theme form */
    try {
      var mainEl = qs("#MainContent");
      var headEl = qs(".search-page__header");
      var sec =
        (headEl && headEl.closest && headEl.closest(".shopify-section")) ||
        (bar.closest && bar.closest(".shopify-section"));
      if (mainEl && sec && sec.parentNode === mainEl) {
        /* section → bar → (live later) — never let results jump ahead of the bar */
        if (bar.parentNode !== mainEl || bar.previousElementSibling !== sec) {
          mainEl.insertBefore(bar, sec.nextSibling);
        }
      } else if (headEl && headEl.parentNode && bar.parentNode !== headEl.parentNode) {
        headEl.parentNode.insertBefore(bar, headEl.nextSibling);
      }
    } catch (_mv) {}
    hideAllThemeSearchChrome();
    return bar;
  }

    function ensureLiveMount() {
    var live = qs("[data-sa-search-live]");
    var main = qs("#MainContent") || document.body;
    var searchSection = qs(".search-page__header") ? qs(".search-page__header").closest(".shopify-section, section") : null;

    if (live) {
      /* If live is inside the page header, safely move it out without destroying contents */
      if (live.closest(".search-page__header, search-page-input-component")) {
        if (searchSection && searchSection.parentNode) {
          searchSection.parentNode.insertBefore(live, searchSection.nextSibling);
        } else {
          main.appendChild(live);
        }
      }
      return live;
    }

    live = document.createElement("div");
    live.className = "sa-search-live";
    live.setAttribute("data-sa-search-live", "1");

    if (searchSection && searchSection.parentNode) {
      searchSection.parentNode.insertBefore(live, searchSection.nextSibling);
    } else if (main) {
      main.appendChild(live);
    } else if (document.body) {
      document.body.appendChild(live);
    }
    return live;
  }

  function hideThemeResults() {
    qsa(
      "results-list, .product-grid-container, #product-grid, .main-collection-grid, [data-product-grid]",
    ).forEach(function (el) {
      if (el.closest("[data-sa-search-live]")) return;
      el.setAttribute("data-sa-theme-results-hidden", "1");
      el.style.setProperty("display", "none", "important");
    });
  }

  function showThemeResults() {
    qsa("[data-sa-theme-results-hidden]").forEach(function (el) {
      el.removeAttribute("data-sa-theme-results-hidden");
      el.style.removeProperty("display");
    });
  }

  function syncClear(input, clear) {
    var has = Boolean(String(input.value || "").trim());
    clear.hidden = !has;
    var bar = input && input.closest ? input.closest(".sa-search-bar") : null;
    if (bar) {
      if (has) bar.classList.add("sa-search-bar--has-clear");
      else bar.classList.remove("sa-search-bar--has-clear");
    }
  }

  function setSubmitLoading(bar, busy) {
    if (!bar) return;
    var btn = qs(".sa-search-bar__submit", bar);
    if (!btn) return;
    btn.classList.toggle("is-loading", Boolean(busy));
    if (busy) btn.classList.remove("is-ready");
    btn.disabled = Boolean(busy);
    if (busy) btn.setAttribute("aria-busy", "true");
    else btn.removeAttribute("aria-busy");
    bar.classList.toggle("is-searching", Boolean(busy));
  }

  function updateHint(bar, state) {
    var hint = qs("[data-sa-search-hint]", bar);
    if (!hint) return;
    if (state === "searching") {
      hint.innerHTML = "<span>Searching the catalog...</span>";
      hint.classList.add("is-active");
      return;
    }
    if (state === "ready") {
      hint.innerHTML =
      "<span>Type a keyword</span><span class=\"sa-search-bar__hint-dot\" aria-hidden=\"true\"></span>" +
        "<span>Press search for all products</span><span class=\"sa-search-bar__hint-kbd\" aria-hidden=\"true\">↵</span>";
      hint.classList.remove("is-active");
      return;
    }
    if (state === "done") {
      hint.innerHTML =
        "<span>Refine your keyword</span><span class=\"sa-search-bar__hint-dot\" aria-hidden=\"true\"></span>" +
        "<span>Search again anytime</span>";
      hint.classList.remove("is-active");
    }
  }

  function setUrlQuery(value) {
    try {
      var url = new URL(location.href);
      url.pathname = "/search";
      url.searchParams.set("type", "product");
      if (value) url.searchParams.set("q", value);
      else url.searchParams.delete("q");
      url.searchParams.delete("page");
      var href = url.pathname + (url.search ? url.search : "") + url.hash;
      history.replaceState({ selfaboutSearch: true }, "", href);
    } catch (_e) {}
  }

  function toCents(value) {
    if (value == null || value === "") return null;
    if (typeof value === "object") {
      if (value.amount != null) return toCents(value.amount);
      if (value.cents != null) return toCents(value.cents);
      return null;
    }
    var raw = String(value).trim().replace(/,/g, "");
    if (!raw) return null;
    if (raw.indexOf(".") !== -1) {
      var major = Number(raw);
      return Number.isFinite(major) ? Math.round(major * 100) : null;
    }
    var n = Number(raw);
    if (!Number.isFinite(n)) return null;
    /* Suggest sometimes returns major units as small ints (24 → Rs.0.24 bug). */
    if (Number.isInteger(n) && Math.abs(n) > 0 && Math.abs(n) < 1000) {
      return Math.round(n * 100);
    }
    return Math.round(n);
  }

  function isBundleProduct(product) {
    var tags = product.tags;
    if (typeof tags === "string") tags = tags.split(",");
    if (
      /bundle|kit/i.test(product.title || "") ||
      /bundle|kit/i.test(product.type || "") ||
      /bundle|kit/i.test(product.product_type || "")
    ) {
      return true;
    }
    if (Array.isArray(tags)) {
      return tags.some(function (t) {
        var s = String(t || "").trim().toLowerCase();
        return (
          s === "selfabout-bundle" ||
          s === "selfabout-kit" ||
          /bundle|kit/i.test(s)
        );
      });
    }
    return false;
  }

  function collectImages(product) {
    var out = [];
    var seen = Object.create(null);
    function push(src) {
      if (!src) return;
      if (typeof src === "object") src = src.src || src.url || "";
      src = String(src || "").trim();
      if (!src || seen[src]) return;
      seen[src] = 1;
      out.push(src);
    }
    if (Array.isArray(product.images)) {
      product.images.forEach(function (img) {
        push(img);
      });
    }
    push(product.featured_image);
    push(product.image);
    push(product.imageUrl);
    if (product.featuredImage) push(product.featuredImage.url || product.featuredImage);
    return out;
  }

  function notifyCards(root) {
    try {
      document.dispatchEvent(
        new CustomEvent("selfabout:dom-updated", {
          detail: { root: root || document },
        }),
      );
    } catch (_e) {}
  }

  function productCardHtml(product, index) {
    product = normalizeCatalogProduct(product) || product;
    if (!product || !product.handle) return "";

    var url = product.url || "/products/" + product.handle;
    var title = product.title || "Product";
    var images = collectImages(product);
    var img = images[0] || "";
    var priceCents =
      product.priceCents != null
        ? product.priceCents
        : toCents(product.price != null ? product.price : product.price_min);
    var compareCents =
      product.compareCents != null
        ? product.compareCents
        : toCents(
            product.compare_at_price_min != null
              ? product.compare_at_price_min
              : product.compare_at_price,
          );
    var price = priceCents != null ? formatMoney(priceCents) : "";
    var onSale =
      compareCents != null && priceCents != null && compareCents > priceCents;
    var savePct = onSale
      ? Math.max(
          1,
          Math.round(((compareCents - priceCents) / compareCents) * 100),
        )
      : 0;
    var available = product.available !== false;
    var isBundle = isBundleProduct(product);
    var variantId = product.variantId || "";
    var variantCount = Number(product.variantCount) || 1;
    var delay = ((index || 0) % 8) * 40;
    var productId = product.id != null ? String(product.id) : "";

    var badges = "";
    if (!available) {
      badges =
        '<span class="selfabout-collection__badge selfabout-collection__badge--sold">Sold out</span>';
    } else {
      if (savePct > 0) {
        badges +=
          '<span class="selfabout-collection__badge selfabout-collection__badge--save sa-card-off" data-sa-card-off="' +
          savePct +
          '" aria-label="' +
          savePct +
          '% off">-' +
          savePct +
          "%</span>";
      }
      if (isBundle) {
        badges +=
          '<a class="selfabout-collection__badge selfabout-collection__badge--kit" href="' +
          BUNDLES_HREF +
          '" data-selfabout-kit-badge>Bundle</a>';
      }
    }

    var thumbs = "";
    if (images.length > 1) {
      thumbs =
        '<ul class="selfabout-collection__kit-includes" aria-label="' +
        (isBundle ? "Bundle items" : "Product images") +
        '">';
      images.slice(0, 5).forEach(function (src, i) {
        thumbs +=
          "<li><button type=\"button\" class=\"selfabout-collection__kit-thumb" +
          (i === 0 ? " is-active" : "") +
          '" data-kit-pick="' +
          i +
          '" data-kit-src="' +
          escapeAttr(src) +
          '" aria-pressed="' +
          (i === 0 ? "true" : "false") +
          '" aria-label="Show image ' +
          (i + 1) +
          '"><img src="' +
          escapeAttr(src) +
          '" alt="" width="36" height="36" loading="lazy"></button></li>';
      });
      if (images.length > 5) {
        thumbs +=
          '<li class="selfabout-collection__kit-more">+' +
          (images.length - 5) +
          "</li>";
      }
      thumbs += "</ul>";
    }

    var actions =
      '<div class="selfabout-collection__actions" data-selfabout-card-actions>' +
      '<button type="button" class="selfabout-collection__save" data-selfabout-save data-handle="' +
      escapeAttr(product.handle) +
      '" data-title="' +
      escapeAttr(title) +
      '" data-url="' +
      escapeAttr(url) +
      '" data-image="' +
      escapeAttr(img) +
      '" data-price="' +
      escapeAttr(price) +
      '" aria-pressed="false" aria-label="Save ' +
      escapeAttr(title) +
      '"><span class="selfabout-collection__btn-label">Save</span><span class="selfabout-collection__btn-spinner" aria-hidden="true"></span></button>';

    if (available && variantCount > 1) {
      actions +=
        '<button type="button" class="selfabout-collection__quick" data-selfabout-quick-view data-product-url="' +
        escapeAttr(url) +
        '.js" aria-haspopup="dialog"><span class="selfabout-collection__btn-label">Quick view</span><span class="selfabout-collection__btn-spinner" aria-hidden="true"></span></button>';
    } else if (available && variantCount <= 1 && variantId) {
      actions +=
        '<div class="selfabout-collection__cart-slot" data-selfabout-cart-slot data-variant-id="' +
        escapeAttr(String(variantId)) +
        '"><button type="button" class="selfabout-collection__quick" data-selfabout-quick-add data-variant-id="' +
        escapeAttr(String(variantId)) +
        '" data-label="Quick add"><span class="selfabout-collection__btn-label">Quick add</span><span class="selfabout-collection__btn-spinner" aria-hidden="true"></span></button></div>';
    } else {
      actions +=
        '<a class="selfabout-collection__quick selfabout-collection__quick--link" href="' +
        escapeAttr(url) +
        '" data-selfabout-view-details>View details</a>';
    }
    actions += "</div>";

    var priceHtml = "";
    if (price) {
      priceHtml =
        '<p class="selfabout-collection__price"><span class="selfabout-collection__price-current">' +
        escapeHtml(price) +
        "</span>";
      if (onSale) {
        priceHtml +=
          '<s class="selfabout-collection__price-compare">' +
          escapeHtml(formatMoney(compareCents)) +
          "</s>";
      }
      priceHtml += "</p>";
    }

    return (
      '<article class="selfabout-collection__card sa-reveal is-in" data-selfabout-card' +
      (productId ? ' data-product-id="' + escapeAttr(productId) + '"' : "") +
      ' data-product-handle="' +
      escapeAttr(product.handle) +
      '" data-sa-product-handle="' +
      escapeAttr(product.handle) +
      '"' +
      (priceCents != null ? ' data-sa-price-cents="' + priceCents + '"' : "") +
      (compareCents != null
        ? ' data-sa-compare-cents="' + compareCents + '"'
        : "") +
      (variantId
        ? ' data-variant-id="' + escapeAttr(String(variantId)) + '"'
        : "") +
      ' data-variant-count="' +
      variantCount +
      '" data-available="' +
      (available ? "true" : "false") +
      '"' +
      (isBundle ? ' data-sa-kit="1"' : "") +
      ' style="--sa-reveal-delay:' +
      delay +
      'ms">' +
      '<div class="selfabout-collection__media-wrap">' +
      '<a class="selfabout-collection__media" href="' +
      escapeAttr(url) +
      '" tabindex="-1" aria-hidden="true">' +
      (img
        ? '<img class="selfabout-collection__img selfabout-collection__img--primary" src="' +
          escapeAttr(img) +
          '" alt="" width="360" height="360" loading="lazy" />' +
          (images[1]
            ? '<img class="selfabout-collection__img selfabout-collection__img--alt" src="' +
              escapeAttr(images[1]) +
              '" alt="" width="360" height="360" loading="lazy" />'
            : "")
        : '<span class="selfabout-collection__placeholder" aria-hidden="true"></span>') +
      "</a>" +
      '<div class="selfabout-collection__badges">' +
      badges +
      "</div></div>" +
      thumbs +
      actions +
      '<div class="selfabout-collection__meta">' +
      '<h2 class="selfabout-collection__card-title"><a href="' +
      escapeAttr(url) +
      '">' +
      escapeHtml(title) +
      "</a></h2>" +
      priceHtml +
      '<p class="sa-offer-cart sa-offer-cart--card" data-sa-offer-cart-slot hidden></p>' +
      '<p class="sa-offer-ship sa-offer-ship--card" data-sa-offer-ship-slot hidden></p>' +
      "</div></article>"
    );
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, "&#39;");
  }

  var BUNDLES_HREF =
    "/collections/all?sa_type=bundle&sort_by=created-descending";
  var SHOP_HREF = "/collections/all?sort_by=created-descending";

  function rememberBundlesNav() {
    try {
      sessionStorage.setItem("sa-nav", "bundles");
    } catch (_e) {}
    try {
      document.documentElement.setAttribute("data-sa-nav", "bundles");
    } catch (_e2) {}
  }

  function emptyStateHtml(title, body) {
    return (
      '<div class="sa-search-empty" data-sa-search-empty="1">' +
      '<h2 class="sa-search-empty__title">' +
      escapeHtml(title) +
      "</h2>" +
      '<p class="sa-search-empty__body">' +
      escapeHtml(body) +
      "</p>" +
      '<div class="sa-search-empty__actions">' +
      '<a class="sa-search-empty__primary" data-sa-browse-bundles data-sa-nav-key="bundles" href="' +
      BUNDLES_HREF +
      '">Browse bundles</a>' +
      '<a class="sa-search-empty__ghost" href="' +
      SHOP_HREF +
      '">Shop all</a>' +
      "</div></div>"
    );
  }

  function renderEmpty(live, message) {
    live.innerHTML = emptyStateHtml(
      message || "Nothing matched that search",
      "Try a simpler keyword, or jump into Shop all and Bundles.",
    );
  }

  function pendingHtml(message) {
    return (
      '<div class="sa-search-live__pending" role="status" aria-live="polite">' +
      '<span class="sa-search-live__pending-spin" aria-hidden="true"></span>' +
      "<p>" +
      escapeHtml(message || "Finding the best matches...") +
      "</p>" +
      "</div>"
    );
  }

  function wireSearchCards(live) {
    notifyCards(live);
    function tryRefresh() {
      var plp = live && live.querySelector("[data-sa-search-plp]");
      if (!plp) return false;
      if (
        window.SelfAboutCollection &&
        typeof window.SelfAboutCollection.refreshSearchPlp === "function"
      ) {
        window.SelfAboutCollection.refreshSearchPlp(plp);
        return true;
      }
      return false;
    }
    if (tryRefresh()) return;
    [80, 250, 700, 1500].forEach(function (ms) {
      window.setTimeout(tryRefresh, ms);
    });
  }

  function renderProductGrid(live, products, label) {
    if (!live) return;
    if (!products || !products.length) {
      renderEmpty(live);
      return;
    }
    var count = products.length;
    var countLabel =
      count === 1 ? "1 result" : count + " results";
    var html =
      '<p class="sa-search-results-label">' +
      escapeHtml(label || "Products & bundles") +
      '<span class="sa-search-results-count" aria-label="' +
      escapeAttr(countLabel) +
      '">' +
      escapeHtml(String(count)) +
      "</span></p>" +
      '<section class="selfabout-collection selfabout-collection--search" data-selfabout-collection data-sa-search-plp="1" data-storage-key="selfabout_saved_products">' +
      '<div class="selfabout-collection__grid" data-selfabout-collection-grid data-density="3">';
    products.forEach(function (p, i) {
      html += productCardHtml(p, i);
    });
    html +=
      "</div>" +
      '<div class="selfabout-collection__qv-backdrop" data-selfabout-qv-backdrop hidden></div>' +
      '<div class="selfabout-collection__qv" data-selfabout-qv role="dialog" aria-modal="true" aria-label="Quick view" hidden>' +
      '<button type="button" class="selfabout-collection__qv-close" data-selfabout-qv-close aria-label="Close">&times;</button>' +
      '<div class="selfabout-collection__qv-body" data-selfabout-qv-body>' +
      '<div class="selfabout-collection__qv-skeleton" aria-hidden="true"></div>' +
      "</div></div>" +
      "</section>";
    live.innerHTML = html;
    wireSearchCards(live);
  }

  function normalizeCatalogProduct(raw) {
    if (!raw) return null;
    if (raw._saNorm) return raw;

    var handle = raw.handle;
    if (!handle && raw.url) {
      var match = String(raw.url).match(/\/products\/([^/?#]+)/i);
      handle = match && match[1] ? decodeURIComponent(match[1]) : "";
    }
    if (!handle) return null;

    var variants = Array.isArray(raw.variants) ? raw.variants : [];
    var available = raw.available;
    if (available == null && variants.length) {
      available = variants.some(function (v) {
        return v && v.available !== false;
      });
    }
    if (available == null) available = true;

    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available !== false) {
        variant = variants[i];
        break;
      }
    }
    if (!variant && variants.length) variant = variants[0];

    var priceCents = toCents(
      variant && variant.price != null
        ? variant.price
        : raw.price_min != null
          ? raw.price_min
          : raw.price,
    );
    var compareCents = toCents(
      variant && variant.compare_at_price != null
        ? variant.compare_at_price
        : raw.compare_at_price_min != null
          ? raw.compare_at_price_min
          : raw.compare_at_price,
    );

    var tags = raw.tags;
    if (typeof tags === "string") {
      tags = tags
        .split(",")
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean);
    }

    var images = collectImages(raw);

    return {
      _saNorm: 1,
      id: raw.id,
      title: raw.title || "Product",
      handle: handle,
      url: raw.url || "/products/" + handle,
      type: raw.product_type || raw.type || "",
      product_type: raw.product_type || raw.type || "",
      vendor: raw.vendor || "",
      tags: tags || [],
      available: Boolean(available),
      variantId: variant && variant.id != null ? variant.id : raw.variant_id || "",
      variantCount: variants.length || Number(raw.variants_count) || 1,
      price: priceCents != null ? priceCents / 100 : null,
      price_min: priceCents != null ? priceCents / 100 : null,
      priceCents: priceCents,
      compare_at_price: compareCents != null ? compareCents / 100 : null,
      compare_at_price_min: compareCents != null ? compareCents / 100 : null,
      compareCents: compareCents,
      featured_image: images[0] || "",
      image: images[0] || "",
      images: images,
    };
  }

  function fetchDefaultCatalog() {
    if (catalogCache) return Promise.resolve(catalogCache);
    if (catalogPromise) return catalogPromise;
    catalogPromise = (function () {
      var all = [];
      var page = 1;
      var maxPages = 1;

      function next() {
        return fetch(
          "/collections/all/products.json?limit=250&page=" + page,
          {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          },
        )
          .then(function (res) {
            if (!res.ok) throw new Error("catalog " + res.status);
            return res.json();
          })
          .then(function (data) {
            var products = (data && data.products) || [];
            products.forEach(function (raw) {
              var normalized = normalizeCatalogProduct(raw);
              if (normalized) all.push(normalized);
            });
            if (products.length >= 250 && page < maxPages) {
              page += 1;
              return next();
            }
            catalogCache = all;
            return all;
          });
      }

      return next().catch(function () {
        catalogPromise = null;
        return fetch("/products.json?limit=250", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        })
          .then(function (res) {
            if (!res.ok) throw new Error("products");
            return res.json();
          })
          .then(function (data) {
            var products = ((data && data.products) || [])
              .map(normalizeCatalogProduct)
              .filter(Boolean);
            catalogCache = products;
            return products;
          })
          .catch(function () {
            return [];
          });
      });
    })();
    return catalogPromise;
  }

  function showDefaultCatalog() {
    var gen = ++defaultGen;
    var bar = qs("[data-sa-search-bar]");
    var live = ensureLiveMount();
    hideThemeResults();
    setSubmitLoading(bar, false);
    if (bar) {
      var btn = qs(".sa-search-bar__submit", bar);
      if (btn) btn.classList.remove("is-ready");
    }
    updateHint(bar, "ready");
    live.classList.add("is-loading");
    live.innerHTML = pendingHtml("Loading products & bundles...");

    return fetchDefaultCatalog().then(function (products) {
      if (gen !== defaultGen) return;
      if (String(lastQ || "").trim()) return;
      live.classList.remove("is-loading");
      if (!products || !products.length) {
        live.innerHTML = emptyStateHtml(
          "Search SelfAbout",
          "Type a keyword, then press the search icon — we’ll surface the best matches.",
        );
        return;
      }
      updateHint(bar, "ready");
      renderProductGrid(live, products, "All products & bundles");
    });
  }

  function normalizeSuggestProducts(data) {
    var resources = (data && data.resources) || data || {};
    var products =
      resources.products ||
      (resources.results && resources.results.products) ||
      data.products ||
      [];
    return Array.isArray(products) ? products : [];
  }

  function productMatchesQuery(product, query) {
    var q = String(query || "")
      .trim()
      .toLowerCase();
    if (!q) return true;
    var hay = [
      product.title,
      product.handle,
      product.type,
      product.product_type,
      product.vendor,
      (product.tags || []).join(" "),
    ]
      .join(" ")
      .toLowerCase();
    var tokens = q.split(/\s+/).filter(Boolean);
    if (!tokens.length) return true;
    return tokens.every(function (token) {
      return hay.indexOf(token) !== -1;
    });
  }

  function runLiveSearch(value, options) {
    options = options || {};
    value = String(value || "").trim();
    if (!options.force && value === lastQ) return;
    lastQ = value;
    setUrlQuery(value);

    var bar = qs("[data-sa-search-bar]");
    var live = ensureLiveMount();
    hideThemeResults();

    if (!value) {
      showDefaultCatalog();
      return;
    }

    defaultGen += 1;
    setSubmitLoading(bar, true);
    updateHint(bar, "searching");
    live.classList.add("is-loading");
    live.innerHTML = pendingHtml("Finding the best matches...");

    if (liveAbort && liveAbort.abort) {
      try {
        liveAbort.abort();
      } catch (_a) {}
    }
    liveAbort =
      typeof AbortController !== "undefined" ? new AbortController() : null;

    var suggest =
      "/search/suggest.json?q=" +
      encodeURIComponent(value) +
      "&resources[type]=product&resources[limit]=24&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag";

    var started = Date.now();

    fetch(suggest, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      signal: liveAbort && liveAbort.signal,
    })
      .then(function (res) {
        if (!res.ok) throw new Error("suggest");
        return res.json();
      })
      .then(function (data) {
        return normalizeSuggestProducts(data).filter(function (product) {
          return productMatchesQuery(product, value);
        });
      })
      .then(function (products) {
        /* Keep spinner visible long enough to feel intentional */
        var wait = Math.max(0, 80 - (Date.now() - started));
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            resolve(products);
          }, wait);
        });
      })
      .then(function (products) {
        live.classList.remove("is-loading");
        setSubmitLoading(bar, false);
        updateHint(bar, "done");
        if (!products || !products.length) {
          renderEmpty(live);
          return;
        }
        renderProductGrid(live, products, "Products & bundles");
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        live.classList.remove("is-loading");
        setSubmitLoading(bar, false);
        updateHint(bar, "ready");
        if (options.hardOnFail) {
          location.assign(
            "/search?type=product&q=" + encodeURIComponent(value),
          );
          return;
        }
        renderEmpty(live, "Nothing matched that search");
      });
  }

  function bindBar(bar) {
    if (!bar || bar.dataset.saBound === "1") return;
    bar.dataset.saBound = "1";
    var input = qs(".sa-search-bar__input", bar);
    var clear = qs(".sa-search-bar__clear", bar);
    var submit = qs(".sa-search-bar__submit", bar);
    if (!input || !clear || !submit) return;

    var q = currentQuery();
    if (q) input.value = q;
    syncClear(input, clear);
    updateHint(bar, q ? "done" : "ready");

    function submitSearch() {
      if (submit.classList.contains("is-loading")) return;
      var value = String(input.value || "").trim();
      submit.classList.remove("is-ready");
      /* Empty query = show full catalog (products + bundles) */
      runLiveSearch(value, { force: true });
    }

    clear.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      input.value = "";
      lastQ = null;
      syncClear(input, clear);
      submit.classList.remove("is-ready");
      updateHint(bar, "ready");
      input.focus();
      setSubmitLoading(bar, false);
      runLiveSearch("", { force: true });
    });

    submit.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      submitSearch();
    });

    /* No realtime search — only update clear visibility while typing */
    input.addEventListener("input", function () {
      syncClear(input, clear);
      lastQ = null;
      if (!String(input.value || "").trim()) {
        updateHint(bar, "ready");
      return;
    }
      if (!submit.classList.contains("is-loading")) {
        var hint = qs("[data-sa-search-hint]", bar);
        if (hint) {
          hint.innerHTML =
            "<span>Ready when you are</span><span class=\"sa-search-bar__hint-dot\" aria-hidden=\"true\"></span>" +
            "<span>Press search</span><span class=\"sa-search-bar__hint-kbd\" aria-hidden=\"true\">↵</span>";
          hint.classList.remove("is-active");
        }
        submit.classList.add("is-ready");
      }
    });

    input.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;
      event.preventDefault();
      submitSearch();
    });
  }

  function polishHeading() {
    qsa(
      ".search-page__header .text-block, .search-page__header h1, .search-page__header h2, .search-page__header .h2",
    ).forEach(function (el) {
      var t = (el.textContent || "").trim();
      if (/^search$/i.test(t) || !t) el.textContent = "Search";
    });
  }

    function boot() {
    markBody();
    polishHeading();
    hideAllThemeSearchChrome();
    var bar = ensureBar();
    bindBar(bar);
    var live = ensureLiveMount();
    hideThemeResults();
    
    var q = currentQuery();
    if (q) {
      if (lastQ !== q) runLiveSearch(q, { force: true });
    } else {
      var hasGrid = live && live.querySelector(".selfabout-collection__grid, .selfabout-collection__card, .sa-search-empty");
      if (!hasGrid) {
        showDefaultCatalog();
      }
    }
    
    document.documentElement.classList.add("sa-search-polished");
    if (bar) {
      bar.hidden = false;
      bar.style.removeProperty("display");
    }
  }

  /* Browse bundles must keep sa_type — never land on plain Shop all */
  document.addEventListener(
    "click",
    function (event) {
      var a =
        event.target &&
        event.target.closest &&
        event.target.closest(
          "[data-sa-browse-bundles], a.sa-search-empty__primary",
        );
      if (!a) return;
      var label = (a.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (
        !a.hasAttribute("data-sa-browse-bundles") &&
        label.indexOf("bundle") === -1
      ) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      rememberBundlesNav();
      window.location.assign(BUNDLES_HREF);
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  window.setTimeout(boot, 120);
  window.setTimeout(boot, 600);
  window.setTimeout(boot, 1400);
  /* Never leave search FOUC-hidden forever if an unrelated script throws —
     but only polish once our bar (or live mount) actually exists. */
  window.setTimeout(function () {
    if (
      document.querySelector("[data-sa-search-bar], .sa-search-bar, [data-sa-search-live]")
    ) {
      document.documentElement.classList.add("sa-search-polished");
    }
  }, 2200);

  /* Theme may re-mount search UI — keep ours on top */
  try {
    var obsTimer = null;
    var obs = new MutationObserver(function () {
      if (obsTimer) return;
      obsTimer = window.setTimeout(function () {
        obsTimer = null;
        hideAllThemeSearchChrome();
        var bar = ensureBar();
        bindBar(bar);
      }, 80);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (_o) {}
})();
